module.exports = __webpack_public_path__ + "static/media/artist-rush-album-10.497e9fea.jpg";